import { IDLE_TIMEOUT_MS } from './session-lifecycle';

const VISIT_KEY = 'flamio_visit';

interface StoredVisit {
  id: string;
  lastActivityAt: number;
}

// Per-tab fallback when localStorage is unavailable (private mode / blocked).
let memoryVisit: StoredVisit | null = null;

// The shared visit id, kept in localStorage so every tab of the origin joins one
// visit. A new visit starts once the previous has been idle past IDLE_TIMEOUT_MS.
// Call on meaningful activity to advance the visit and on init to join it.
export function touchVisit(now: number = Date.now()): string {
  const prev = readVisit();
  const visit: StoredVisit =
    prev && now - prev.lastActivityAt <= IDLE_TIMEOUT_MS
      ? { id: prev.id, lastActivityAt: now }
      : { id: crypto.randomUUID(), lastActivityAt: now };
  writeVisit(visit);
  return visit.id;
}

function readVisit(): StoredVisit | null {
  try {
    const raw = localStorage.getItem(VISIT_KEY);
    return raw ? (JSON.parse(raw) as StoredVisit) : null;
  } catch {
    return memoryVisit;
  }
}

function writeVisit(visit: StoredVisit): void {
  memoryVisit = visit;
  try {
    localStorage.setItem(VISIT_KEY, JSON.stringify(visit));
  } catch {
    // localStorage blocked — the in-memory fallback holds for this tab.
  }
}
